<div class="topbar-viewmode-container">

    <app-toggle-button></app-toggle-button>

    @if (show) {
        <button (click)="changeViewMode('presentation')" class="presentation-button"
                data-bs-placement="bottom" data-bs-toggle="tooltip" title="Präsentationsmodus">
            <img [class.ie]="isIE" alt="Auf Präsentationsmodus umschalten"
                 src="{{ assetService.getUrl('presentation-mode.png') }}">
        </button>
    }
</div>
